module.exports = __webpack_public_path__ + "static/media/motorcyk-motorcycle-blog-one2.ca5ccac9.jpg";